import { SectionHead } from "./SectionHead";

const ITEMS = [
  ["The AI Experience", "Working demonstrations through the day — what can actually be built, shown by the people who build it.", "/images/vision-experience-v4.webp", "g-1-7", ""],
  ["The Summit Dinner", "The evening, for the room. Long tables, one conversation continuing.", "/images/vision-dinner-v5.webp", "g-8-12", "tall"],
  ["Built to travel", "Broadcast-grade production. Flagship sessions cut within 24 hours; full sessions on demand through the year.", "/images/vision-broadcast-v3.webp", "g-3-10", ""],
];

export const Beyond = () => (
  <section className="ns-sec" id="beyond" data-testid="ns-beyond">
    <div className="ns-wrap">
      <SectionHead nr="05" label="Beyond the stage" right="Concept visualisations" />
      <div className="ns-grid">
        <div className="g-1-8">
          <h2 className="ns-h2" data-rv data-testid="ns-beyond-h">The day does not end when the stage goes dark.</h2>
        </div>
        <div className="g-9-12">
          <p className="ns-lede" data-rv style={{ "--d": ".1s" }} data-testid="ns-beyond-lede">The AI Experience, the Summit Dinner and a broadcast built to travel — designed as one experience, not a programme with side events.</p>
        </div>
        {ITEMS.map(([t, d, src, col, tall], i) => (
          <figure key={t} className={`ns-bfig ${col} ${tall}`} data-testid={`ns-beyond-item-${i + 1}`}>
            <div data-rv="wipe" style={{ "--d": `${0.1 * i}s` }}><div className="ns-fig"><img src={src} alt={t} loading="lazy" /></div></div>
            <figcaption data-rv style={{ "--d": `${0.3 + 0.1 * i}s` }}><span className="t">{t}</span><span className="d">{d}</span><span className="c">Concept visualisation</span></figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
